module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.claimFromList),
      expression: "!claimFromList"
    }]
  }, [(_vm.claimFromList) ? _c('div', [(_vm.isGen3) ? _c('div', [_c('view-claim-gen3')], 1) : _c('div', [_c('view-claim-gen2')], 1)]) : _vm._e()])
},staticRenderFns: []}